/* ==========================================================================
   BEHIND - STICKY ADD TO CART VISIBILITY (PRODUCT PAGE, PHONE ONLY)
   Custom code for Behind. Kept separate from the Prestige core files so the
   theme stays easy to update.

   Loaded by sections/main-product.liquid, only when the sticky Add to Cart
   bar is switched on together with "Always show until button is visible" in
   the Theme Editor, and only when the product is available.

   WHAT THIS DOES
   Prestige's own <product-sticky-bar> shows itself once the real, in-page
   Add to Cart button has scrolled out of view. Behind instead wants the
   sticky bar visible the instant the page opens, and hidden only while the
   real button is actually on screen - shown again as soon as it leaves. This
   file watches the real button with an IntersectionObserver and toggles two
   classes on <html>, which is all the CSS in custom-behind.css needs to take
   over the bar's visibility (scoped to a phone-only max-width query):

     custom-sticky-managed  - added once a real button has been found, so the
                              CSS knows to run this behavior instead of
                              leaving Prestige's native rules alone.
     custom-atc-visible     - present while the real button is on screen,
                              absent while it is not. The CSS hides the
                              sticky bar while this class is present.

   The bar must never flash the wrong state on load, so the very first
   reading is taken synchronously with getBoundingClientRect before the
   IntersectionObserver's first callback has a chance to fire (which can
   arrive a frame or two late).

   FINDING THE RIGHT BUTTON
   The sticky bar's own Add to Cart button is also a <buy-buttons
   class="buy-buttons"> element, so the real one is found by taking every
   ".buy-buttons" on the page and skipping the one that lives inside
   ".product-sticky-bar".

   RE-RENDERS
   The real button lives inside <product-rerender>, which Prestige replaces
   with freshly rendered markup whenever the variant changes. A
   MutationObserver watches the page for that and re-attaches the
   IntersectionObserver to the new button. The old button disappearing for a
   moment mid-swap never clears custom-atc-visible on its own - the state
   only ever changes on a definite new reading of an actual button.

   Guarded by a window flag so re-running this file (Theme Editor section
   reloads re-execute inline/deferred scripts) never creates a second set of
   observers.
   ========================================================================== */

(function () {
  'use strict';

  if (window.behindStickyBarReady) {
    return;
  }

  window.behindStickyBarReady = true;

  var root = document.documentElement;
  var atcObserver = null;
  var currentButton = null;

  function findMainButton() {
    var candidates = document.querySelectorAll('.buy-buttons');

    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('.product-sticky-bar')) {
        return candidates[i];
      }
    }

    return null;
  }

  function setVisible(isVisible) {
    if (isVisible) {
      root.classList.add('custom-atc-visible');
    } else {
      root.classList.remove('custom-atc-visible');
    }
  }

  function isOnScreen(element) {
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.bottom > 0 && rect.top < viewportHeight;
  }

  function watch(button) {
    if (!button || button === currentButton) {
      return;
    }

    if (atcObserver) {
      atcObserver.disconnect();
    }

    currentButton = button;
    root.classList.add('custom-sticky-managed');

    /* Set the correct state immediately and synchronously, so the sticky bar
       never flashes visible-then-hidden (or the other way round) on first
       paint or right after a re-render. */
    setVisible(isOnScreen(button));

    if (!window.IntersectionObserver) {
      /* No IntersectionObserver support: the synchronous reading above is
         still correct for the current scroll position, it just will not
         keep updating as the shopper scrolls. Graceful, not broken. */
      return;
    }

    atcObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        setVisible(entries[i].isIntersecting);
      }
    });

    atcObserver.observe(button);
  }

  function attach() {
    var button = findMainButton();

    /* A variant re-render briefly removes the old button before the new one
       lands. Nothing about the visible/hidden state changes during that
       gap - it only ever updates once a real button is found again. */
    if (button) {
      watch(button);
    }
  }

  attach();

  if (window.MutationObserver) {
    var rerenderObserver = new MutationObserver(function () {
      attach();
    });

    rerenderObserver.observe(document.body, {
      subtree: true,
      childList: true
    });
  }
})();
